'use client'

import dynamic from 'next/dynamic'

export const YandexPayWidgetClient = dynamic(
	() => import('./YandexPayWidget').then(({ YandexPayWidget }) => YandexPayWidget),
	{
		ssr: false
	}
)
